$('.slider-for').slick({
	slidesToShow: 1,
	slidesToScroll: 1,
	arrows: false,
	fade: true,
	centerMode: true,
	asNavFor: '.slider-nav'
});


$('.slider-nav').slick({
	slidesToShow: 4,
	slidesToScroll: 1,
	asNavFor: '.slider-for',
	dots: false,
	focusOnSelect: true
});

	
/*
$('.more').readmore({
	speed: 300,
	collapsedHeight: 335,
	moreLink: '<a href="#" class="read-more">Read more</a>',
	lessLink: '<a href="#" class="read-less">Read less</a>',
	heightMargin: 16
});
*/

$('.more').readmore({
  speed: 75,
  lessLink: '<a class="read-more" href="#">Read less</a>',
  moreLink: '<a class="read-more" href="#">Read more</a>',
  embedCSS: true,
  collapsedHeight: 280
});

	
$(document).ready(() => {
  // Mobile Nav
  $('.trigger-secondary').click(function() {
    $(this)
      .next()
      .fadeIn();
    $(this)
      .closest('.nav-menu')
      .addClass('secondary-open');
  });
  $('.close-secondary').click(function() {
    $(this)
      .closest('.secondary-links')
      .fadeOut();
    $(this)
      .closest('.nav-menu')
      .removeClass('secondary-open');
  });
  $('.trigger-tertiary').click(function() {
    $(this)
      .next()
      .fadeIn();
    $(this)
      .closest('.secondary-links')
      .addClass('tertiary-open');
  });
  $('.close-tertiary').click(function() {
    $(this)
      .closest('.tertiary-links')
      .fadeOut();
    $(this)
      .closest('.secondary-links')
      .removeClass('tertiary-open');
  });
  $('.mobile-menu-trigger').click(() => {
    $('.mobile-menu').addClass('open');
    $('body').css('overflow-y', 'hidden');
  });
  $('.mobile-menu .close-menu').click(() => {
    console.log('clicked');
    $('.mobile-menu').removeClass('open');
    $('body').css('overflow', '');
  });
});

var homeArtistSwiper = new Swiper('.swiper.artist-slider', {
	slidesPerView: 2,
	spaceBetween: 0,
  	loop: false,
      navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
  	},
  	pagination: {
  	  el: '.swiper-pagination',
      clickable: true,
  	},
  	breakpoints: {
      768: {
        slidesPerView: 4,
      },
  	},
});

var testimonialSwiper = new Swiper('.swiper.testimonial-slider', {
	slidesPerView: 1,
	spaceBetween: 0,
  	loop: true,
      navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
  	},
      autoplay: {
      delay: 8000,
    },
});

var blogSwiper = new Swiper('.swiper.blog-slider', {
	slidesPerView: 2,
	spaceBetween: 0,
  	loop: true,
    slidesPerGroup: 2,
    loopFillGroupWithBlank: true,
	touchRatio: 1,
  	pagination: {
  	  el: '.swiper-pagination',
      clickable: true,
  	},
  	breakpoints: {
      768: {
        slidesPerView: 4,
      },
      1024: {
        slidesPerView: 6,
    	touchRatio: 0,
  		loop: false,
      },
  	},
});

var gallerySwiper = new Swiper('.swiper.gallery-slider', {
	slidesPerView: 3,
	spaceBetween: 0,
  	loop: true,
      navigation: {
      nextEl: '.swiper-button-next.v2',
      prevEl: '.swiper-button-prev.v2',
  	},
});

var galleryThumbs = new Swiper('.swiper.gallery-thumbs', {
  spaceBetween: 10,
  slidesPerView: 4,
  loop: false,
  freeMode: true,
  loopedSlides: 5,
  watchSlidesVisibility: true,
  watchSlidesProgress: true,
  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev', 
  },
});

var galleryTop = new Swiper('.swiper.gallery-top', {
  autoHeight: true,
  spaceBetween: 10,
  loop: true,
  loopedSlides: 5,
  thumbs: {
  	swiper: galleryThumbs,
  },
  breakpoints: {
    750: {
  	  loop: false,
    },
  },
});

$(document).ready(function(){
	$(".refine-options").slideUp();
});
$(".refine-button").click(function(){
	$(".refine-options").toggle;
	$(".refine-options").slideToggle();
    $("svg").toggleClass("down");
});

// Smooth scroll
$(function() {
  $('.smoothScroll').click(function() {
    if (location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '') && location.hostname == this.hostname) {
      var target = $(this.hash);
      target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');
      if (target.length) {
        $('html,body').animate({
          scrollTop: target.offset().top
        }, 700);
        return false;
      }
    }
  });
});

// Accordion
$(document).ready(function() {
  $(".accordion > a").on("click", function() {
    if ($(this).hasClass("active")) {
      $(this).removeClass("active");
      $(this)
        .siblings(".content")
        .slideUp(600);
      $(".accordion > a i")
        .removeClass("fa-minus")
        .addClass("fa-plus");
    } else {
      $(".accordion > a i")
        .removeClass("fa-minus")
        .addClass("fa-plus");
      $(this)
        .find("i")
        .removeClass("fa-plus")
        .addClass("fa-minus");
      $(".accordion > a").removeClass("active");
      $(this).addClass("active");
      $(".content").slideUp(600);
      $(this)
        .siblings(".content")
        .slideDown(600);
    }
  });
});

